/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AddFavoriteResourceDto {
  /** @format int32 */
  resourceId?: number;
}

export interface AddRnToConversationDto {
  /** @format uuid */
  rnId?: string;
  /** @format uuid */
  ownerId?: string;
}

export interface AddSharedResourceDto {
  /** @format int32 */
  resourceId?: number;
  /** @format uuid */
  userId?: string;
}

export interface ADTA05Address {
  streetAddress?: string | null;
  streetAddress2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
}

export interface ADTA05ContactInformation {
  phone?: string | null;
  cell?: string | null;
  email?: string | null;
}

export interface ADTA05Name {
  firstName?: string | null;
  middleName?: string | null;
  lastName?: string | null;
}

export interface ApplicationUserDto {
  /** @format uuid */
  id?: string;
  deviceToken?: string | null;
  profile?: ApplicationUserProfileDto;
  canManageSubscription?: boolean;
}

export interface ApplicationUserDtoPagedResponse {
  /** @format int32 */
  page?: number;
  resources?: ApplicationUserDto[] | null;
  /** @format int32 */
  totalResources?: number;
  /** @format int32 */
  totalPages?: number;
}

export interface ApplicationUserProfileDto {
  email?: string | null;
  login?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  avatarUri?: string | null;
  birthdate?: Date;
  zipCode?: string | null;
  mobilePhone?: string | null;
  role?: string | null;
  /** @format uuid */
  ummaId?: string;
  ummaVerified?: boolean;
  ummaOnboarded?: boolean;
  ummaEmailSummariesEnabled?: boolean;
  subscriptionStatus?: SubscriptionStatus;
  subscriptionEndDateUtc?: Date;
  delivered?: boolean;
  deliveryDate?: Date;
  actualDeliveryDate?: Date;
  isLoss?: boolean | null;
  highRiskFlags?: HighRiskTypeDto[] | null;
  isHighRisk?: boolean;
  createdDateUtc?: Date;
  subscriptionCreatedDate?: Date;
  membershipType?: string | null;
  freeTrialEndDate?: Date;
  hasUnlimitedLactationCalls?: boolean;
}

export interface BirthCertificateInformationDto {
  sendBirthCertificationInfo?: boolean;
  parentsMariedOrInStateRegisteredPartnership?: boolean;
  patientName?: ADTA05Name;
  socialSecurityNumber?: string | null;
  dateOfBirth?: Date;
  maidenName?: string | null;
  birthPlace?: string | null;
  patientAddress?: ADTA05Address;
  patientContactInformation?: ADTA05ContactInformation;
  mailingAddress?: ADTA05Address;
  mailingAddressCounty?: string | null;
  firstPrenatalVisitDate?: Date;
  /** @format int32 */
  weightPrePregnancy?: number;
  /** @format int32 */
  heightFeet?: number;
  /** @format int32 */
  heightInches?: number;
  /** @format int32 */
  numberOfChildrenLiving?: number;
  /** @format int32 */
  numberOfCesareanBirths?: number;
  dateOfLastLiveBirth?: Date;
  /** @format int32 */
  numberOfChildrenDeceased?: number;
  /** @format int32 */
  terminatedWithinFirst20WeeksMiscarriage?: number;
  /** @format int32 */
  terminatedAfter20WeeksStillbirth?: number;
  dateOfLastTermination?: Date;
  didParentReceiveWICFood?: boolean;
  didParentSmoke?: boolean;
  declineToProvideRaceAndEthnicity?: boolean;
  isHispanicOrLatina?: boolean;
  raceEthnicity?: string | null;
  declineToProvideSexualOrientationAndGenderIdentity?: boolean;
  sexOnBirthCertificate?: string | null;
  genderIdentity?: string | null;
  sexualOrientation?: string | null;
  declineToProvideOccupationAndSchooling?: boolean;
  occupation?: string | null;
  businessIndustry?: string | null;
  /** @format int32 */
  yearsOfSchooling?: number;
}

export interface CallCommentDto {
  /** @format int32 */
  starRating?: number;
  comment?: string | null;
  /** @format uuid */
  careteamUserId?: string | null;
  workerType?: WorkerType;
}

export enum CallStatus {
  Queued = "Queued",
  Ringing = "Ringing",
  InProgress = "InProgress",
  Completed = "Completed",
  Busy = "Busy",
  Failed = "Failed",
  NoAnswer = "NoAnswer",
  Canceled = "Canceled",
}

export interface CallSummaryCategoryDto {
  /** @format uuid */
  id?: string;
  name?: string | null;
  options?: CallSummaryOptionDto[] | null;
}

export interface CallSummaryDto {
  /** @format uuid */
  id?: string | null;
  categories?: CallSummaryCategoryDto[] | null;
  notes?: string | null;
  caller?: ConversationUserDto;
  callee?: ConversationUserDto;
  callDate?: Date;
}

export interface CallSummaryOptionDto {
  /** @format uuid */
  id?: string;
  value?: string | null;
  active?: boolean;
}

export enum CallToActionDeepLink {
  Profile = "Profile",
  CareTeam = "CareTeam",
  AskMyDoctor = "AskMyDoctor",
  Subscription = "Subscription",
  Resources = "Resources",
  Interests = "Interests",
}

export interface CareteamAskMyDoctorCreateDto {
  /** @format uuid */
  momId?: string;
  questions?: CheckListItemCreateDto[] | null;
}

export interface CareTeamCheckListItemDeleteDto {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  momId?: string;
}

export interface CareteamCheckListItemDto {
  /** @format uuid */
  id?: string;
  text?: string | null;
  checked?: boolean;
  /** @format uuid */
  momId?: string;
}

export interface CareteamDeliveryDayCreateDto {
  /** @format uuid */
  momId?: string;
  items?: CheckListItemCreateDto[] | null;
}

export interface CareTeamMemberDto {
  /** @format int32 */
  id?: number;
  /** @format uuid */
  key?: string;
  role?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  videoUrl?: string | null;
  avatarUri?: string | null;
  about?: string | null;
  quote?: string | null;
  experience?: string | null;
  education?: string | null;
  title?: string | null;
  languages?: string[] | null;
  interests?: string[] | null;
  guideWelcomeMessage?: string | null;
  shift?: string | null;
  /** @format int32 */
  yearsOfExperience?: number;
  certifications?: string | null;
  workplaces?: string | null;
  hideTeamMemberInMobileApp?: boolean;
}

export interface ChangeEmailConfirmationDto {
  email?: string | null;
  verificationCode?: string | null;
}

export interface ChangeEmailDto {
  email?: string | null;
}

export interface ChangeEmailSummarySettingDto {
  emailSummariesEnabled?: boolean;
}

export interface ChangeMobilePhoneDto {
  mobilePhone?: string | null;
}

export interface CheckListAuditDto {
  dateLastModified?: Date;
  lastEditedBy?: string | null;
}

export interface CheckListItemCreateDto {
  text?: string | null;
  checked?: boolean;
}

export interface ChecklistItemDeleteDto {
  /** @format uuid */
  id?: string;
}

export interface CheckListItemDto {
  /** @format uuid */
  id?: string;
  text?: string | null;
  checked?: boolean;
}

export enum CheckoutProduct {
  OneMonth = "OneMonth",
  ThreeMonths = "ThreeMonths",
  SixMonths = "SixMonths",
  Tier1 = "Tier1",
  Tier2 = "Tier2",
  LactationCall = "LactationCall",
}

export interface ConfirmEmailDto {
  email?: string | null;
  verificationCode?: string | null;
}

export enum ContentEventTypes {
  RemoveResources = "RemoveResources",
  RemoveSurveyAnswers = "RemoveSurveyAnswers",
  CareTeamDeleted = "CareTeamDeleted",
  CareTeamCreated = "CareTeamCreated",
  CareTeamTrashed = "CareTeamTrashed",
  ResourceCategoriesPublished = "ResourceCategoriesPublished",
  ResourceCategoriesUnpublished = "ResourceCategoriesUnpublished",
  ResourceCategoriesTrashed = "ResourceCategoriesTrashed",
  MinimumVersionsPublished = "MinimumVersionsPublished",
  ContentResourcesPublished = "ContentResourcesPublished",
  ContentResourcesUnpublished = "ContentResourcesUnpublished",
  ContentResourcesTrashed = "ContentResourcesTrashed",
  SurveyQuestionsPublished = "SurveyQuestionsPublished",
  SurveyQuestionsUnpublished = "SurveyQuestionsUnpublished",
  SurveyQuestionsTrashed = "SurveyQuestionsTrashed",
  RemoveCallSummaryOptions = "RemoveCallSummaryOptions",
  RemoveCallSummaryCategories = "RemoveCallSummaryCategories",
  CallSummaryOptionsPublished = "CallSummaryOptionsPublished",
  CallSummaryCategoriesPublished = "CallSummaryCategoriesPublished",
  AdminAvatarPublished = "AdminAvatarPublished",
}

export interface ConversationDto {
  /** @format uuid */
  ownerId?: string | null;
  participants?: ConversationUserDto[] | null;
  sid?: string | null;
  friendlyName?: string | null;
  /** @format uuid */
  uniqueName?: string;
  /** @format int32 */
  lastMessageIndex?: number | null;
  latestMessagePreview?: string | null;
  lastMessageTimeStamp?: Date;
  hasUnreadAskMyDoctorQuestions?: boolean;
  hasUnreadDeliveryDayItems?: boolean;
  deliveryDate?: Date;
  ageString?: string | null;
  isLoss?: boolean;
  delivered?: boolean;
  isHighRisk?: boolean;
  momSubscriptionStatus?: SubscriptionStatus;
  momSubscriptionEndDateUtc?: Date;
}

export interface ConversationDtoPagedResponse {
  /** @format int32 */
  page?: number;
  resources?: ConversationDto[] | null;
  /** @format int32 */
  totalResources?: number;
  /** @format int32 */
  totalPages?: number;
}

export interface ConversationUserDto {
  /** @format uuid */
  userId?: string;
  firstName?: string | null;
  lastName?: string | null;
  avatarUri?: string | null;
  role?: string | null;
  isOnline?: boolean;
  lastReadTimestamp?: Date;
  /** @format int32 */
  lastReadMessageIndex?: number;
}

export interface CreateADT05Dto {
  dueDate?: Date;
  lastMenstrualPeriod?: Date;
  isMultiples?: boolean;
  isCSection?: boolean;
  isSurrogate?: boolean;
  deliveryLocation?: string | null;
  patientName?: ADTA05Name;
  priorName?: string | null;
  dateOfBirth?: Date;
  socialSecurityNumber?: string | null;
  declineToProvideSocialSecurityNumber?: boolean;
  mrNumber?: string | null;
  preferredLanguage?: string | null;
  priorPatient?: boolean;
  patientAddress?: ADTA05Address;
  patientContactInformation?: ADTA05ContactInformation;
  receiveHoagEmails?: boolean;
  providerName?: string | null;
  /** @format int32 */
  providerId?: number;
  nextOfKinName?: ADTA05Name;
  nextOfKinDateOfBirth?: Date;
  nextOfKinRelationship?: string | null;
  nextOfKinAddress?: ADTA05Address;
  nextOfKinContactInformation?: ADTA05ContactInformation;
  babyCovered?: boolean;
  primaryInsurance?: string | null;
  primaryInsuranceType?: string | null;
  memberId?: string | null;
  groupNumber?: string | null;
  priorAuthNumber?: string | null;
  subscriberName?: ADTA05Name;
  subscriberBirthdate?: Date;
  insuranceAddress?: ADTA05Address;
  insuranceContactInformation?: ADTA05ContactInformation;
  insuranceFilesBase64?: string[] | null;
  photoIdFilesBase64?: string[] | null;
  preferredContactMethod?: PreferredContactMethod;
  npiNumber?: string | null;
  birthCertificateInformation?: BirthCertificateInformationDto;
}

export interface CreateCareTeamNoteResponse {
  note?: NoteDto;
}

export interface CreateCareTeamVideoAccessTokenDto {
  /** @format uuid */
  roomOwnerId?: string;
}

export interface CreateConversationAccessTokenResponse {
  accessToken?: string | null;
}

export interface CreateMultipleCareTeamDeliveryDayItemsResponse {
  items?: CheckListItemDto[] | null;
}

export interface CreateNoteDto {
  text?: string | null;
  /** @format uuid */
  momId?: string;
}

export interface CreateVideoAccessTokenResponse {
  accessToken?: string | null;
}

export interface CreateVoiceAccessTokenResponse {
  accessToken?: string | null;
}

export interface DeepLinkDto {
  link?: CallToActionDeepLink;
  /** @format uuid */
  momId?: string;
  message?: string | null;
}

export interface DeleteAskMyDoctorResponse {
  question?: CheckListItemDto;
}

export interface DeleteCareTeamNoteResponse {
  note?: NoteDto;
}

export interface DeleteDeliveryDayItemResponse {
  question?: CheckListItemDto;
}

export interface DeleteFavoriteResourceDto {
  /** @format int32 */
  resourceId?: number;
}

export interface DeleteUserDto {
  /** @format uuid */
  userId?: string;
}

export interface ErrorResponse {
  /** @format int32 */
  statusCode?: number;
  errorCode?: string | null;
  message?: string | null;
}

export interface ForgotPasswordDto {
  email?: string | null;
}

export interface GenerateCheckoutUrlResponse {
  url?: string | null;
}

export interface GenerateCustomerPortalUrlResponse {
  url?: string | null;
}

export interface GetActiveLactationCheckoutSessionResponse {
  /** @format int32 */
  sessionCount?: number;
}

export interface GetAvailableRnsResponse {
  rns?: ConversationUserDto[] | null;
}

export interface GetCallSummaryCategoriesResponse {
  categories?: CallSummaryCategoryDto[] | null;
}

export interface GetCareTeamConversationUniqueNameResponse {
  uniqueName?: string | null;
}

export interface GetCareTeamMemberResponse {
  member?: CareTeamMemberDto;
}

export interface GetCareTeamResponse {
  careTeam?: CareTeamMemberDto[] | null;
}

export interface GetConversationResponse {
  conversation?: ConversationDto;
}

export interface GetHighRiskTypesResponse {
  types?: HighRiskTypeDto[] | null;
}

export interface GetInsuranceProvidersResponse {
  name?: string | null;
  value?: string | null;
}

export interface GetInsuranceProvidersResponsePagedResponse {
  /** @format int32 */
  page?: number;
  resources?: GetInsuranceProvidersResponse[] | null;
  /** @format int32 */
  totalResources?: number;
  /** @format int32 */
  totalPages?: number;
}

export interface GetJoinedConversationsResponse {
  conversations?: ConversationDto[] | null;
}

export interface GetMinimumVersionsResponse {
  required?: string | null;
  recommended?: string | null;
}

export interface GetMomUnreadMessageCountResponse {
  /** @format int32 */
  unreadMessageCount?: number;
}

export interface GetMyConversationResponse {
  conversations?: ConversationDto[] | null;
  /** @format int32 */
  page?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  totalResources?: number;
  careTeamConversation?: ConversationDto;
}

export interface GetOnboardingSurveyResponse {
  firstName?: string | null;
  lastName?: string | null;
  questions?: SurveyQuestionDto[] | null;
  categories?: SurveyResourceCategoryDto[] | null;
  children?: UserChildDto[] | null;
}

export interface GetPrenatalRoadmapeResponse {
  resources?: ResourceItemDto[] | null;
}

export interface GetProvidersByIdsResponse {
  /** @format int32 */
  id?: number;
  name?: string | null;
  profileImage?: string | null;
  clinicName?: string | null;
  providerId?: string | null;
}

export interface GetProvidersResponse {
  /** @format int32 */
  id?: number;
  name?: string | null;
}

export interface GetProvidersResponsePagedResponse {
  /** @format int32 */
  page?: number;
  resources?: GetProvidersResponse[] | null;
  /** @format int32 */
  totalResources?: number;
  /** @format int32 */
  totalPages?: number;
}

export interface GetResourceCategoriesResponse {
  categories?: ResourceCategoryDto[] | null;
}

export interface GetResourceCategoryResponse {
  category?: ResourceCategoryDto;
  types?: ResourceTypeDto[] | null;
}

export interface GetResourceLandingResponse {
  categories?: ResourceCategoryDto[] | null;
  favorites?: ResourceItemDto[] | null;
  shared?: ResourceItemDto[] | null;
}

export interface GetResourceResponse {
  resource?: ResourceItemDto;
}

export interface GetTriageNumberResponse {
  phone?: string | null;
}

export interface GetUnreadMessageConversationsResponse {
  conversations?: ConversationDto[] | null;
}

export interface GetUnreadMessageCountResponse {
  /** @format int32 */
  unreadMessageCount?: number;
}

export interface GetUsersAvailableToAnswerCallsResponse {
  userIds?: string[] | null;
  message?: string | null;
  allWorkersBusy?: boolean;
  inOperationHours?: boolean;
  /** @format int32 */
  numberOfAvailableLactationCalls?: number;
}

export interface GuideOnlineStatusDto {
  isOnCall?: boolean;
}

export interface HighRiskTypeDto {
  type?: string | null;
  /** @format uuid */
  id?: string;
}

export interface JoinConversationsDto {
  userIds?: string[] | null;
}

export interface JoinConversationsResponse {
  failedUserIds?: string[] | null;
}

export interface LactationCallEndedDto {
  /** @format uuid */
  fromMomUserId?: string;
}

export interface LeaveConversationDto {
  /** @format uuid */
  ownerId?: string;
}

export interface LeaveConversationForAdminDto {
  /** @format uuid */
  ownerId?: string;
}

export interface LinkDto {
  /** @format uuid */
  momId?: string;
  text?: string | null;
  link?: string | null;
}

export interface NoteDto {
  /** @format uuid */
  authorId?: string;
  author?: string | null;
  text?: string | null;
  createdDateUtc?: Date;
  lastModifiedDateUtc?: Date;
  /** @format uuid */
  momId?: string;
  /** @format uuid */
  id?: string;
  editable?: boolean | null;
  role?: string | null;
}

export interface NoteDtoPagedResponse {
  /** @format int32 */
  page?: number;
  resources?: NoteDto[] | null;
  /** @format int32 */
  totalResources?: number;
  /** @format int32 */
  totalPages?: number;
}

export interface OktaInlineHookPayloadDataContextDto {
  user?: OktaInlineHookPayloadDataContextUserDto;
}

export interface OktaInlineHookPayloadDataContextUserDto {
  id?: string | null;
}

export interface OktaInlineHookPayloadDataDto {
  context?: OktaInlineHookPayloadDataContextDto;
}

export interface OktaInlineHookPayloadDto {
  data?: OktaInlineHookPayloadDataDto;
}

export interface OktaInlineHookResponseCommandDto {
  type?: string | null;
  value?: OktaInlineHookResponseCommandValueDto[] | null;
}

export interface OktaInlineHookResponseCommandValueDto {
  op?: string | null;
  path?: string | null;
  value?: any;
}

export interface OktaInlineHookResponseDto {
  commands?: OktaInlineHookResponseCommandDto[] | null;
}

export interface OktaWebhookPayloadDataDto {
  events?: OktaWebhookPayloadDataEventDto[] | null;
}

export interface OktaWebhookPayloadDataEventDto {
  eventType?: string | null;
  target?: OktaWebhookPayloadDataEventTargetDto[] | null;
}

export interface OktaWebhookPayloadDataEventTargetDto {
  id?: string | null;
  type?: string | null;
}

export interface OktaWebhookPayloadDto {
  data?: OktaWebhookPayloadDataDto;
}

export interface PagedCheckListItemResponse {
  /** @format int32 */
  page?: number;
  resources?: CheckListItemDto[] | null;
  /** @format int32 */
  totalResources?: number;
  /** @format int32 */
  totalPages?: number;
  dateLastModified?: Date;
  lastEditedBy?: string | null;
}

export enum PreferredContactMethod {
  Phone = "Phone",
  Email = "Email",
}

export interface ProblemDetails {
  type?: string | null;
  title?: string | null;
  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
}

export interface RegisterDto {
  email?: string | null;
  password?: string | null;
  birthdate?: Date;
  registrationCode?: string | null;
}

export interface RemoveAdminFromConversationDto {
  /** @format uuid */
  removeUserId?: string;
  /** @format uuid */
  ownerId?: string;
}

export interface RemoveCareTeamMemberFromConversationDto {
  /** @format uuid */
  removeUserId?: string;
  /** @format uuid */
  ownerId?: string;
}

export interface RemoveNoteDto {
  /** @format uuid */
  id?: string;
}

export interface RemoveSharedResourceDto {
  /** @format int32 */
  resourceId?: number;
  /** @format uuid */
  userId?: string;
}

export interface ResetPasswordDto {
  email?: string | null;
  password?: string | null;
  verificationCode?: string | null;
}

export interface ResourceCategoryDto {
  /** @format int32 */
  id?: number;
  title?: string | null;
  description?: string | null;
  thumbnailUrl?: string | null;
  headerImageUrl?: string | null;
}

export interface ResourceItemDto {
  /** @format int32 */
  id?: number;
  title?: string | null;
  thumbnailUrl?: string | null;
  publishedDate?: Date;
  type?: ResourceTypeEnum;
  category?: string | null;
  isFavorite?: boolean;
  isShared?: boolean;
  requiresSubscription?: boolean;
}

export interface ResourceItemDtoPagedResponse {
  /** @format int32 */
  page?: number;
  resources?: ResourceItemDto[] | null;
  /** @format int32 */
  totalResources?: number;
  /** @format int32 */
  totalPages?: number;
}

export interface ResourceTypeDto {
  /** @format int32 */
  id?: number;
  name?: string | null;
}

export enum ResourceTypeEnum {
  Article = "Article",
  Class = "Class",
  Service = "Service",
  Audio = "Audio",
  Video = "Video",
}

export interface SearchConversationsResponse {
  conversations?: ConversationDto[] | null;
  /** @format int32 */
  page?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  totalResources?: number;
}

export interface SendConfirmationEmailDto {
  email?: string | null;
}

export interface SharedWebhookEventDto {
  event?: ContentEventTypes;
}

export interface ShareResourceCareTeamDto {
  /** @format int32 */
  resourceId?: number;
}

export enum SubscriptionStatus {
  None = "None",
  Active = "Active",
  PastDue = "PastDue",
  Canceled = "Canceled",
  FreeTrial = "FreeTrial",
}

export interface SurveyAnswerDto {
  /** @format int32 */
  questionId?: number;
  userReplies?: SurveyAnswerReplyDto[] | null;
}

export interface SurveyAnswerReplyDto {
  isOther?: boolean;
  reply?: string | null;
}

export interface SurveyQuestionDto {
  /** @format int32 */
  id?: number;
  title?: string | null;
  type?: string | null;
  question?: string | null;
  description?: string | null;
  canSkip?: boolean;
  allowOther?: boolean;
  options?: string[] | null;
  userReplies?: SurveyAnswerReplyDto[] | null;
}

export interface SurveyResourceCategoryDto {
  /** @format int32 */
  id?: number;
  title?: string | null;
  description?: string | null;
  thumbnailUrl?: string | null;
  headerImageUrl?: string | null;
  selected?: boolean;
}

export interface UpdateCareTeamNoteResponse {
  note?: NoteDto;
}

export interface UpdateNoteDto {
  text?: string | null;
  /** @format uuid */
  id?: string;
}

export interface UpdatePasswordDto {
  oldPassword?: string | null;
  newPassword?: string | null;
}

export interface UpdateSubscriptionProductPriceResponse {
  billingProduct?: CheckoutProduct;
}

export interface UpsertAskMyDoctorResponse {
  question?: CheckListItemDto;
}

export interface UpsertCallSummaryDto {
  /** @format uuid */
  conversationOwnerId?: string;
  messageSid?: string | null;
  optionIds?: string[] | null;
  notes?: string | null;
}

export interface UpsertDeliveryDayItemResponse {
  item?: CheckListItemDto;
}

export interface UpsertDeliveryProfileDto {
  delivered?: boolean;
  deliveryDate?: Date;
  actualDeliveryDate?: Date;
  /** @format uuid */
  momId?: string | null;
  isLoss?: boolean | null;
  highRiskFlags?: HighRiskTypeDto[] | null;
  isHighRisk?: boolean;
}

export interface UpsertOnboardingSurveyDto {
  firstName?: string | null;
  lastName?: string | null;
  answers?: SurveyAnswerDto[] | null;
  children?: UserChildDto[] | null;
  categoryIds?: number[] | null;
}

export interface UpsertPushDeviceTokenDto {
  deviceToken?: string | null;
  firebaseToken?: string | null;
  isIos?: boolean | null;
}

export interface UserChildDto {
  name?: string | null;
  birthday?: Date;
}

export enum WorkerType {
  Nurse = "nurse",
  Lc = "lc",
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData
          ? { "Content-Type": type }
          : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Hoag Web API
 * @version 1
 *
 * Allowed hosts: hoag-api.intdev.ciedigital.net, localhost
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Account
     * @name V1AccountCreateCreate
     * @summary [Unprotected]
     * @request POST:/api/v1/Account/create
     * @secure
     */
    v1AccountCreateCreate: (data: RegisterDto, params: RequestParams = {}) =>
      this.request<ApplicationUserDto, any>({
        path: `/api/v1/Account/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name V1AccountSendConfirmationEmailCreate
     * @summary [Unprotected]
     * @request POST:/api/v1/Account/sendConfirmationEmail
     * @secure
     */
    v1AccountSendConfirmationEmailCreate: (
      data: SendConfirmationEmailDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/Account/sendConfirmationEmail`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name V1AccountConfirmEmailCreate
     * @summary [Unprotected]
     * @request POST:/api/v1/Account/confirmEmail
     * @secure
     */
    v1AccountConfirmEmailCreate: (
      data: ConfirmEmailDto,
      params: RequestParams = {},
    ) =>
      this.request<ApplicationUserDto, any>({
        path: `/api/v1/Account/confirmEmail`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name V1AccountForgotPasswordCreate
     * @summary [Unprotected]
     * @request POST:/api/v1/Account/forgotPassword
     * @secure
     */
    v1AccountForgotPasswordCreate: (
      data: ForgotPasswordDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/Account/forgotPassword`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name V1AccountResetPasswordCreate
     * @summary [Unprotected]
     * @request POST:/api/v1/Account/resetPassword
     * @secure
     */
    v1AccountResetPasswordCreate: (
      data: ResetPasswordDto,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/Account/resetPassword`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name V1AccountChangeMobilePhoneCreate
     * @summary [Roles: user,guide] [Policy: RequireVerifiedUser]
     * @request POST:/api/v1/Account/changeMobilePhone
     * @secure
     */
    v1AccountChangeMobilePhoneCreate: (
      data: ChangeMobilePhoneDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/v1/Account/changeMobilePhone`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name V1AccountChangeEmailCreate
     * @summary [Roles: user] [Policy: RequireVerifiedUser]
     * @request POST:/api/v1/Account/changeEmail
     * @secure
     */
    v1AccountChangeEmailCreate: (
      data: ChangeEmailDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/v1/Account/changeEmail`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name V1AccountChangeEmailConfirmationCreate
     * @summary [Roles: user] [Policy: RequireVerifiedUser]
     * @request POST:/api/v1/Account/changeEmailConfirmation
     * @secure
     */
    v1AccountChangeEmailConfirmationCreate: (
      data: ChangeEmailConfirmationDto,
      params: RequestParams = {},
    ) =>
      this.request<ApplicationUserDto, void>({
        path: `/api/v1/Account/changeEmailConfirmation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name V1AccountChangeEmailSummarySettingCreate
     * @summary [Roles: user] [Policy: RequireVerifiedUser]
     * @request POST:/api/v1/Account/changeEmailSummarySetting
     * @secure
     */
    v1AccountChangeEmailSummarySettingCreate: (
      data: ChangeEmailSummarySettingDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/v1/Account/changeEmailSummarySetting`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name V1AccountUpdatePasswordCreate
     * @summary [Roles: guide,rn,user,admin,lc] [Policy: RequireVerifiedUser]
     * @request POST:/api/v1/Account/updatePassword
     * @secure
     */
    v1AccountUpdatePasswordCreate: (
      data: UpdatePasswordDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/v1/Account/updatePassword`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name V1AccountUpdateUserProfileCreate
     * @summary [Roles: user] [Policy: RequireVerifiedUser]
     * @request POST:/api/v1/Account/updateUserProfile
     * @secure
     */
    v1AccountUpdateUserProfileCreate: (
      data: {
        DeleteExistingAvatarImage?: boolean;
        FirstName?: string;
        LastName?: string;
        Birthdate?: Date;
        ActualDeliveryDate?: Date;
        ZipCode?: string;
        Delivered?: boolean;
        DeliveryDate?: Date;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApplicationUserDto, void>({
        path: `/api/v1/Account/updateUserProfile`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name V1AccountUpdateDeliveryProfileCreate
     * @summary [Roles: user] [Policy: RequireVerifiedUser]
     * @request POST:/api/v1/Account/updateDeliveryProfile
     * @secure
     */
    v1AccountUpdateDeliveryProfileCreate: (
      data: UpsertDeliveryProfileDto,
      params: RequestParams = {},
    ) =>
      this.request<UpsertDeliveryProfileDto, void>({
        path: `/api/v1/Account/updateDeliveryProfile`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name V1AccountCareTeamUpdateDeliveryProfileCreate
     * @summary [Roles: guide] [Policy: RequireVerifiedUser]
     * @request POST:/api/v1/Account/careTeam/updateDeliveryProfile
     * @secure
     */
    v1AccountCareTeamUpdateDeliveryProfileCreate: (
      data: UpsertDeliveryProfileDto,
      params: RequestParams = {},
    ) =>
      this.request<UpsertDeliveryProfileDto, void>({
        path: `/api/v1/Account/careTeam/updateDeliveryProfile`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name V1AccountUserProfileList
     * @summary [Roles: guide,rn,user,admin,lc] [Policy: RequireUmmaIdClaim]
     * @request GET:/api/v1/Account/userProfile
     * @secure
     */
    v1AccountUserProfileList: (params: RequestParams = {}) =>
      this.request<ApplicationUserDto, void>({
        path: `/api/v1/Account/userProfile`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name V1AccountCareTeamUserProfileList
     * @summary [Roles: rn,guide,admin] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/Account/careTeam/userProfile
     * @secure
     */
    v1AccountCareTeamUserProfileList: (
      query?: {
        /** @format uuid */
        UserId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApplicationUserDto, void>({
        path: `/api/v1/Account/careTeam/userProfile`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name V1AccountSearchList
     * @summary [Roles: admin] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/Account/search
     * @secure
     */
    v1AccountSearchList: (
      query?: {
        Role?: string;
        /** @format int32 */
        Page?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApplicationUserDtoPagedResponse, void>({
        path: `/api/v1/Account/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name V1AccountPushTokenUpdate
     * @summary [Roles: guide,rn,user,admin,lc] [Policy: RequireVerifiedUser]
     * @request PUT:/api/v1/Account/pushToken
     * @secure
     */
    v1AccountPushTokenUpdate: (
      data: UpsertPushDeviceTokenDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/v1/Account/pushToken`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account
     * @name V1AccountDelete
     * @summary [Roles: admin,guide] [Policy: RequireVerifiedUser]
     * @request DELETE:/api/v1/Account
     * @secure
     */
    v1AccountDelete: (data: DeleteUserDto, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/v1/Account`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AppConfiguration
     * @name V1AppConfigurationMinimumVersionsList
     * @summary [Unprotected]
     * @request GET:/api/v1/AppConfiguration/minimumVersions
     * @secure
     */
    v1AppConfigurationMinimumVersionsList: (params: RequestParams = {}) =>
      this.request<GetMinimumVersionsResponse, any>({
        path: `/api/v1/AppConfiguration/minimumVersions`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AskMyDoctor
     * @name V1AskMyDoctorCareTeamList
     * @summary [Roles: guide] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/AskMyDoctor/careTeam
     * @secure
     */
    v1AskMyDoctorCareTeamList: (
      query?: {
        /** @format uuid */
        momId?: string;
        includeAnswered?: boolean;
        /** @format int32 */
        page?: number;
        /** @format int32 */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PagedCheckListItemResponse, void>({
        path: `/api/v1/AskMyDoctor/careTeam`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AskMyDoctor
     * @name V1AskMyDoctorCareTeamCreate
     * @summary [Roles: guide] [Policy: RequireVerifiedUser]
     * @request POST:/api/v1/AskMyDoctor/careTeam
     * @secure
     */
    v1AskMyDoctorCareTeamCreate: (
      data: CareteamAskMyDoctorCreateDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/v1/AskMyDoctor/careTeam`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AskMyDoctor
     * @name V1AskMyDoctorCareTeamUpdate
     * @summary [Roles: guide] [Policy: RequireVerifiedUser]
     * @request PUT:/api/v1/AskMyDoctor/careTeam
     * @secure
     */
    v1AskMyDoctorCareTeamUpdate: (
      data: CareteamCheckListItemDto,
      params: RequestParams = {},
    ) =>
      this.request<UpsertAskMyDoctorResponse, void>({
        path: `/api/v1/AskMyDoctor/careTeam`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AskMyDoctor
     * @name V1AskMyDoctorCareTeamDelete
     * @summary [Roles: guide] [Policy: RequireVerifiedUser]
     * @request DELETE:/api/v1/AskMyDoctor/careTeam
     * @secure
     */
    v1AskMyDoctorCareTeamDelete: (
      data: CareTeamCheckListItemDeleteDto,
      params: RequestParams = {},
    ) =>
      this.request<DeleteAskMyDoctorResponse, void>({
        path: `/api/v1/AskMyDoctor/careTeam`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AskMyDoctor
     * @name V1AskMyDoctorList
     * @summary [Roles: user] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/AskMyDoctor
     * @secure
     */
    v1AskMyDoctorList: (
      query?: {
        /** @format int32 */
        page?: number;
        /** @format int32 */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PagedCheckListItemResponse, void>({
        path: `/api/v1/AskMyDoctor`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AskMyDoctor
     * @name V1AskMyDoctorCreate
     * @summary [Roles: user] [Policy: RequireVerifiedUser]
     * @request POST:/api/v1/AskMyDoctor
     * @secure
     */
    v1AskMyDoctorCreate: (
      data: CheckListItemCreateDto,
      params: RequestParams = {},
    ) =>
      this.request<UpsertAskMyDoctorResponse, void>({
        path: `/api/v1/AskMyDoctor`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AskMyDoctor
     * @name V1AskMyDoctorUpdate
     * @summary [Roles: user] [Policy: RequireVerifiedAndSubscribedUser]
     * @request PUT:/api/v1/AskMyDoctor
     * @secure
     */
    v1AskMyDoctorUpdate: (data: CheckListItemDto, params: RequestParams = {}) =>
      this.request<UpsertAskMyDoctorResponse, void>({
        path: `/api/v1/AskMyDoctor`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AskMyDoctor
     * @name V1AskMyDoctorDelete
     * @summary [Roles: user] [Policy: RequireVerifiedUser]
     * @request DELETE:/api/v1/AskMyDoctor
     * @secure
     */
    v1AskMyDoctorDelete: (
      data: ChecklistItemDeleteDto,
      params: RequestParams = {},
    ) =>
      this.request<DeleteAskMyDoctorResponse, void>({
        path: `/api/v1/AskMyDoctor`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AskMyDoctor
     * @name V1AskMyDoctorAuditList
     * @summary [Roles: user,guide,admin] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/AskMyDoctor/audit
     * @secure
     */
    v1AskMyDoctorAuditList: (
      query?: {
        /** @format uuid */
        momId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CheckListAuditDto, void>({
        path: `/api/v1/AskMyDoctor/audit`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AskMyDoctor
     * @name V1AskMyDoctorCopyList
     * @summary [Roles: user] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/AskMyDoctor/copy
     * @secure
     */
    v1AskMyDoctorCopyList: (params: RequestParams = {}) =>
      this.request<PagedCheckListItemResponse, void>({
        path: `/api/v1/AskMyDoctor/copy`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing
     * @name V1BillingCustomerPortalUrlCreate
     * @summary [Roles: user] [Policy: RequireVerifiedAndSubscribedUser]
     * @request POST:/api/v1/Billing/customerPortalUrl
     * @secure
     */
    v1BillingCustomerPortalUrlCreate: (params: RequestParams = {}) =>
      this.request<GenerateCustomerPortalUrlResponse, void>({
        path: `/api/v1/Billing/customerPortalUrl`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing
     * @name V1BillingStripeWebhookEventCreate
     * @summary [Roles: guide,rn,user,admin,lc]
     * @request POST:/api/v1/Billing/stripeWebhookEvent
     * @secure
     */
    v1BillingStripeWebhookEventCreate: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/v1/Billing/stripeWebhookEvent`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing
     * @name V1BillingCheckoutUrlCreate
     * @summary [Roles: user] [Policy: RequireVerifiedUser]
     * @request POST:/api/v1/Billing/checkoutUrl
     * @secure
     */
    v1BillingCheckoutUrlCreate: (
      query?: {
        product?: CheckoutProduct;
        /** @default false */
        includeTrial?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<GenerateCheckoutUrlResponse, void>({
        path: `/api/v1/Billing/checkoutUrl`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing
     * @name V1BillingCheckoutSuccessList
     * @summary [Roles: guide,rn,user,admin,lc]
     * @request GET:/api/v1/Billing/checkoutSuccess
     * @secure
     */
    v1BillingCheckoutSuccessList: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/v1/Billing/checkoutSuccess`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing
     * @name V1BillingCheckoutCancelList
     * @summary [Roles: guide,rn,user,admin,lc]
     * @request GET:/api/v1/Billing/checkoutCancel
     * @secure
     */
    v1BillingCheckoutCancelList: (
      query?: {
        session_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/v1/Billing/checkoutCancel`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing
     * @name V1BillingLactationCheckoutSessionsList
     * @summary [Roles: user] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/Billing/lactationCheckoutSessions
     * @secure
     */
    v1BillingLactationCheckoutSessionsList: (params: RequestParams = {}) =>
      this.request<GetActiveLactationCheckoutSessionResponse, void>({
        path: `/api/v1/Billing/lactationCheckoutSessions`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing
     * @name V1BillingCancelLactationCheckoutSessionCreate
     * @summary [Roles: user] [Policy: RequireVerifiedUser]
     * @request POST:/api/v1/Billing/CancelLactationCheckoutSession
     * @secure
     */
    v1BillingCancelLactationCheckoutSessionCreate: (
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/v1/Billing/CancelLactationCheckoutSession`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing
     * @name V1BillingSubscriptionUpdate
     * @summary [Roles: user] [Policy: RequireVerifiedUser]
     * @request PUT:/api/v1/Billing/subscription
     * @secure
     */
    v1BillingSubscriptionUpdate: (
      query?: {
        product?: CheckoutProduct;
      },
      params: RequestParams = {},
    ) =>
      this.request<UpdateSubscriptionProductPriceResponse, void>({
        path: `/api/v1/Billing/subscription`,
        method: "PUT",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing
     * @name V1BillingSubscriptionList
     * @summary [Roles: user] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/Billing/subscription
     * @secure
     */
    v1BillingSubscriptionList: (params: RequestParams = {}) =>
      this.request<UpdateSubscriptionProductPriceResponse, void>({
        path: `/api/v1/Billing/subscription`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CareTeam
     * @name V1CareTeamList
     * @summary [Roles: guide,rn,user,admin,lc]
     * @request GET:/api/v1/CareTeam
     * @secure
     */
    v1CareTeamList: (
      query?: {
        Role?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetCareTeamResponse, void>({
        path: `/api/v1/CareTeam`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CareTeam
     * @name V1CareTeamMemberList
     * @summary [Roles: guide,rn,user,admin,lc]
     * @request GET:/api/v1/CareTeam/member
     * @secure
     */
    v1CareTeamMemberList: (
      query?: {
        /** @format uuid */
        MemberId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetCareTeamMemberResponse, void>({
        path: `/api/v1/CareTeam/member`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CareTeam
     * @name V1CareTeamNotesCreate
     * @summary [Roles: guide,admin] [Policy: RequireVerifiedUser]
     * @request POST:/api/v1/CareTeam/notes
     * @secure
     */
    v1CareTeamNotesCreate: (data: CreateNoteDto, params: RequestParams = {}) =>
      this.request<CreateCareTeamNoteResponse, void>({
        path: `/api/v1/CareTeam/notes`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CareTeam
     * @name V1CareTeamNotesUpdate
     * @summary [Roles: guide,admin] [Policy: RequireVerifiedUser]
     * @request PUT:/api/v1/CareTeam/notes
     * @secure
     */
    v1CareTeamNotesUpdate: (data: UpdateNoteDto, params: RequestParams = {}) =>
      this.request<UpdateCareTeamNoteResponse, void>({
        path: `/api/v1/CareTeam/notes`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CareTeam
     * @name V1CareTeamNotesDelete
     * @summary [Roles: guide,admin] [Policy: RequireVerifiedUser]
     * @request DELETE:/api/v1/CareTeam/notes
     * @secure
     */
    v1CareTeamNotesDelete: (data: RemoveNoteDto, params: RequestParams = {}) =>
      this.request<DeleteCareTeamNoteResponse, void>({
        path: `/api/v1/CareTeam/notes`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CareTeam
     * @name V1CareTeamNotesList
     * @summary [Roles: guide,admin] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/CareTeam/notes
     * @secure
     */
    v1CareTeamNotesList: (
      query?: {
        /** @format uuid */
        momId?: string;
        /** @format int32 */
        page?: number;
        /** @format int32 */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<NoteDtoPagedResponse, void>({
        path: `/api/v1/CareTeam/notes`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CareTeam
     * @name V1CareTeamUserreportList
     * @summary [Roles: guide,admin] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/CareTeam/userreport
     * @secure
     */
    v1CareTeamUserreportList: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/v1/CareTeam/userreport`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CareTeam
     * @name V1CareTeamHighRiskTypesList
     * @summary [Roles: guide,admin] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/CareTeam/highRiskTypes
     * @secure
     */
    v1CareTeamHighRiskTypesList: (params: RequestParams = {}) =>
      this.request<GetHighRiskTypesResponse, void>({
        path: `/api/v1/CareTeam/highRiskTypes`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CareTeam
     * @name V1CareTeamCareTeamConversationList
     * @summary [Roles: guide,admin,lc] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/CareTeam/careTeamConversation
     * @secure
     */
    v1CareTeamCareTeamConversationList: (params: RequestParams = {}) =>
      this.request<GetCareTeamConversationUniqueNameResponse, void>({
        path: `/api/v1/CareTeam/careTeamConversation`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CareTeam
     * @name V1CareTeamLactationConsultantAvailableList
     * @summary [Roles: user] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/CareTeam/lactationConsultantAvailable
     * @secure
     */
    v1CareTeamLactationConsultantAvailableList: (params: RequestParams = {}) =>
      this.request<GetUsersAvailableToAnswerCallsResponse, void>({
        path: `/api/v1/CareTeam/lactationConsultantAvailable`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CareTeam
     * @name V1CareTeamSetLactationConsultantUnavailableCreate
     * @summary [Roles: lc] [Policy: RequireVerifiedUser]
     * @request POST:/api/v1/CareTeam/setLactationConsultantUnavailable
     * @secure
     */
    v1CareTeamSetLactationConsultantUnavailableCreate: (
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/v1/CareTeam/setLactationConsultantUnavailable`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CareTeam
     * @name V1CareTeamLactationCallEndedCreate
     * @summary [Roles: lc] [Policy: RequireVerifiedUser]
     * @request POST:/api/v1/CareTeam/lactationCallEnded
     * @secure
     */
    v1CareTeamLactationCallEndedCreate: (
      data: LactationCallEndedDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/v1/CareTeam/lactationCallEnded`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CareTeam
     * @name V1CareTeamSetOnCallStatusCreate
     * @summary [Roles: guide] [Policy: RequireVerifiedUser]
     * @request POST:/api/v1/CareTeam/setOnCallStatus
     * @secure
     */
    v1CareTeamSetOnCallStatusCreate: (
      data: GuideOnlineStatusDto,
      params: RequestParams = {},
    ) =>
      this.request<GuideOnlineStatusDto, void>({
        path: `/api/v1/CareTeam/setOnCallStatus`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CareTeam
     * @name V1CareTeamGetOnCallStatusList
     * @summary [Roles: guide] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/CareTeam/getOnCallStatus
     * @secure
     */
    v1CareTeamGetOnCallStatusList: (params: RequestParams = {}) =>
      this.request<GuideOnlineStatusDto, void>({
        path: `/api/v1/CareTeam/getOnCallStatus`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CareTeam
     * @name V1CareTeamNurseDialedCreate
     * @summary [Roles: user] [Policy: RequireVerifiedUser]
     * @request POST:/api/v1/CareTeam/nurseDialed
     * @secure
     */
    v1CareTeamNurseDialedCreate: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/v1/CareTeam/nurseDialed`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Conversations
     * @name V1ConversationsCreateAccessTokenCreate
     * @summary [Roles: guide,rn,user,admin,lc] [Policy: RequireVerifiedUser]
     * @request POST:/api/v1/Conversations/createAccessToken
     * @secure
     */
    v1ConversationsCreateAccessTokenCreate: (params: RequestParams = {}) =>
      this.request<CreateConversationAccessTokenResponse, void>({
        path: `/api/v1/Conversations/createAccessToken`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Conversations
     * @name V1ConversationsConversationUserList
     * @summary [Roles: guide,rn,user,admin,lc] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/Conversations/conversationUser
     * @secure
     */
    v1ConversationsConversationUserList: (
      query?: {
        /** @format uuid */
        UserId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ConversationUserDto, void | ProblemDetails>({
        path: `/api/v1/Conversations/conversationUser`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Conversations
     * @name V1ConversationsCareTeamJoinCreate
     * @summary [Roles: guide,admin] [Policy: RequireVerifiedUser]
     * @request POST:/api/v1/Conversations/careTeam/join
     * @secure
     */
    v1ConversationsCareTeamJoinCreate: (
      data: JoinConversationsDto,
      params: RequestParams = {},
    ) =>
      this.request<JoinConversationsResponse, void>({
        path: `/api/v1/Conversations/careTeam/join`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Conversations
     * @name V1ConversationsCareTeamJoinedList
     * @summary [Roles: rn,guide,admin] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/Conversations/careTeam/joined
     * @secure
     */
    v1ConversationsCareTeamJoinedList: (params: RequestParams = {}) =>
      this.request<GetJoinedConversationsResponse, void>({
        path: `/api/v1/Conversations/careTeam/joined`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags Conversations
 * @name V1ConversationsCareTeamMyConversationsList
 * @summary [Roles: admin,guide] [Policy: RequireVerifiedUser].
This route is deprecated and will be removed in the future, you should use api/v2/Conversations/careTeam/myConversations instead
 * @request GET:/api/v1/Conversations/careTeam/myConversations
 * @deprecated
 * @secure
 */
    v1ConversationsCareTeamMyConversationsList: (
      query?: {
        conversationUniqueName?: string;
        /**
         * @format int32
         * @default 1
         */
        page?: number;
        /**
         * @format int32
         * @default 20
         */
        pageSize?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetMyConversationResponse, void>({
        path: `/api/v1/Conversations/careTeam/myConversations`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Conversations
     * @name V1ConversationsCareTeamUnreadMessageConversationsList
     * @summary [Roles: admin,guide] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/Conversations/careTeam/unreadMessageConversations
     * @secure
     */
    v1ConversationsCareTeamUnreadMessageConversationsList: (
      params: RequestParams = {},
    ) =>
      this.request<GetUnreadMessageConversationsResponse, void>({
        path: `/api/v1/Conversations/careTeam/unreadMessageConversations`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Conversations
     * @name V1ConversationsUnreadMessageCountList
     * @summary [Roles: user] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/Conversations/unreadMessageCount
     * @secure
     */
    v1ConversationsUnreadMessageCountList: (params: RequestParams = {}) =>
      this.request<GetMomUnreadMessageCountResponse, void>({
        path: `/api/v1/Conversations/unreadMessageCount`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Conversations
     * @name V1ConversationsCareTeamOtherList
     * @summary [Roles: guide,admin] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/Conversations/careTeam/other
     * @secure
     */
    v1ConversationsCareTeamOtherList: (
      query?: {
        /** @format int32 */
        Page?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ConversationDtoPagedResponse, void>({
        path: `/api/v1/Conversations/careTeam/other`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Conversations
     * @name V1ConversationsInfoList
     * @summary [Roles: user] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/Conversations/info
     * @secure
     */
    v1ConversationsInfoList: (params: RequestParams = {}) =>
      this.request<GetConversationResponse, void>({
        path: `/api/v1/Conversations/info`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Conversations
     * @name V1ConversationsCareTeamInfoList
     * @summary [Roles: rn,guide,admin,lc] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/Conversations/careTeam/info
     * @secure
     */
    v1ConversationsCareTeamInfoList: (
      query?: {
        /** @format uuid */
        UserId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetConversationResponse, void>({
        path: `/api/v1/Conversations/careTeam/info`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Conversations
     * @name V1ConversationsCareTeamRnAddCreate
     * @summary [Roles: guide,admin] [Policy: RequireVerifiedUser]
     * @request POST:/api/v1/Conversations/careTeam/rn/add
     * @secure
     */
    v1ConversationsCareTeamRnAddCreate: (
      data: AddRnToConversationDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/v1/Conversations/careTeam/rn/add`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Conversations
     * @name V1ConversationsCareTeamRemoveCreate
     * @summary [Roles: guide,admin] [Policy: RequireVerifiedUser]
     * @request POST:/api/v1/Conversations/careTeam/remove
     * @secure
     */
    v1ConversationsCareTeamRemoveCreate: (
      data: RemoveCareTeamMemberFromConversationDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/v1/Conversations/careTeam/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Conversations
     * @name V1ConversationsCareTeamLeaveCreate
     * @summary [Roles: guide] [Policy: RequireVerifiedUser]
     * @request POST:/api/v1/Conversations/careTeam/leave
     * @secure
     */
    v1ConversationsCareTeamLeaveCreate: (
      data: LeaveConversationDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/v1/Conversations/careTeam/leave`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Conversations
     * @name V1ConversationsCareTeamAvailableRnsList
     * @summary [Roles: guide,admin] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/Conversations/careTeam/availableRns
     * @secure
     */
    v1ConversationsCareTeamAvailableRnsList: (
      query?: {
        /** @format uuid */
        UserId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetAvailableRnsResponse, void>({
        path: `/api/v1/Conversations/careTeam/availableRns`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
 * No description
 *
 * @tags Conversations
 * @name V1ConversationsAdminSearchList
 * @summary [Roles: admin] [Policy: RequireVerifiedUser].
This route is deprecated and will be removed in the future, you should use api/v2/Conversations/careTeam/myConversations instead
 * @request GET:/api/v1/Conversations/admin/search
 * @deprecated
 * @secure
 */
    v1ConversationsAdminSearchList: (
      query?: {
        Name?: string;
        /** @format int32 */
        Page?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<SearchConversationsResponse, void>({
        path: `/api/v1/Conversations/admin/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Conversations
     * @name V1ConversationsAdminRemoveCreate
     * @summary [Roles: admin] [Policy: RequireVerifiedUser]
     * @request POST:/api/v1/Conversations/admin/remove
     * @secure
     */
    v1ConversationsAdminRemoveCreate: (
      data: RemoveAdminFromConversationDto,
      params: RequestParams = {},
    ) =>
      this.request<void, ProblemDetails | void>({
        path: `/api/v1/Conversations/admin/remove`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Conversations
     * @name V1ConversationsAdminLeaveCreate
     * @summary [Roles: admin] [Policy: RequireVerifiedUser]
     * @request POST:/api/v1/Conversations/admin/leave
     * @secure
     */
    v1ConversationsAdminLeaveCreate: (
      data: LeaveConversationForAdminDto,
      params: RequestParams = {},
    ) =>
      this.request<void, ProblemDetails | void>({
        path: `/api/v1/Conversations/admin/leave`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Conversations
     * @name V1ConversationsSyncList
     * @summary [Roles: guide,admin] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/Conversations/sync
     * @secure
     */
    v1ConversationsSyncList: (params: RequestParams = {}) =>
      this.request<string, void>({
        path: `/api/v1/Conversations/sync`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Conversations
     * @name V1ConversationsCareTeamDeeplinkCreate
     * @summary [Roles: guide,admin] [Policy: RequireVerifiedUser]
     * @request POST:/api/v1/Conversations/careTeam/deeplink
     * @secure
     */
    v1ConversationsCareTeamDeeplinkCreate: (
      data: DeepLinkDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/v1/Conversations/careTeam/deeplink`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Conversations
     * @name V1ConversationsUnreadMessagesList
     * @summary [Roles: user] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/Conversations/unreadMessages
     * @secure
     */
    v1ConversationsUnreadMessagesList: (params: RequestParams = {}) =>
      this.request<GetUnreadMessageCountResponse, void>({
        path: `/api/v1/Conversations/unreadMessages`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Conversations
     * @name V1ConversationsCareTeamLinkCreate
     * @summary [Roles: guide,admin] [Policy: RequireVerifiedUser]
     * @request POST:/api/v1/Conversations/careTeam/link
     * @secure
     */
    v1ConversationsCareTeamLinkCreate: (
      data: LinkDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/v1/Conversations/careTeam/link`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeliveryDay
     * @name V1DeliveryDayCareTeamList
     * @summary [Roles: guide] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/DeliveryDay/careTeam
     * @secure
     */
    v1DeliveryDayCareTeamList: (
      query?: {
        /** @format uuid */
        momId?: string;
        includeChecked?: boolean;
        /** @format int32 */
        page?: number;
        /** @format int32 */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PagedCheckListItemResponse, void>({
        path: `/api/v1/DeliveryDay/careTeam`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeliveryDay
     * @name V1DeliveryDayCareTeamCreate
     * @summary [Roles: guide] [Policy: RequireVerifiedUser]
     * @request POST:/api/v1/DeliveryDay/careTeam
     * @secure
     */
    v1DeliveryDayCareTeamCreate: (
      data: CareteamDeliveryDayCreateDto,
      params: RequestParams = {},
    ) =>
      this.request<CreateMultipleCareTeamDeliveryDayItemsResponse, void>({
        path: `/api/v1/DeliveryDay/careTeam`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeliveryDay
     * @name V1DeliveryDayCareTeamUpdate
     * @summary [Roles: guide] [Policy: RequireVerifiedUser]
     * @request PUT:/api/v1/DeliveryDay/careTeam
     * @secure
     */
    v1DeliveryDayCareTeamUpdate: (
      data: CareteamCheckListItemDto,
      params: RequestParams = {},
    ) =>
      this.request<UpsertDeliveryDayItemResponse, void>({
        path: `/api/v1/DeliveryDay/careTeam`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeliveryDay
     * @name V1DeliveryDayCareTeamDelete
     * @summary [Roles: guide] [Policy: RequireVerifiedUser]
     * @request DELETE:/api/v1/DeliveryDay/careTeam
     * @secure
     */
    v1DeliveryDayCareTeamDelete: (
      data: CareTeamCheckListItemDeleteDto,
      params: RequestParams = {},
    ) =>
      this.request<DeleteDeliveryDayItemResponse, void>({
        path: `/api/v1/DeliveryDay/careTeam`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeliveryDay
     * @name V1DeliveryDayList
     * @summary [Roles: user] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/DeliveryDay
     * @secure
     */
    v1DeliveryDayList: (
      query?: {
        /** @format int32 */
        page?: number;
        /** @format int32 */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PagedCheckListItemResponse, void>({
        path: `/api/v1/DeliveryDay`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeliveryDay
     * @name V1DeliveryDayCreate
     * @summary [Roles: user] [Policy: RequireVerifiedUser]
     * @request POST:/api/v1/DeliveryDay
     * @secure
     */
    v1DeliveryDayCreate: (
      data: CheckListItemCreateDto,
      params: RequestParams = {},
    ) =>
      this.request<UpsertDeliveryDayItemResponse, void>({
        path: `/api/v1/DeliveryDay`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeliveryDay
     * @name V1DeliveryDayUpdate
     * @summary [Roles: user] [Policy: RequireVerifiedUser]
     * @request PUT:/api/v1/DeliveryDay
     * @secure
     */
    v1DeliveryDayUpdate: (data: CheckListItemDto, params: RequestParams = {}) =>
      this.request<UpsertDeliveryDayItemResponse, void>({
        path: `/api/v1/DeliveryDay`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeliveryDay
     * @name V1DeliveryDayDelete
     * @summary [Roles: user] [Policy: RequireVerifiedUser]
     * @request DELETE:/api/v1/DeliveryDay
     * @secure
     */
    v1DeliveryDayDelete: (
      data: ChecklistItemDeleteDto,
      params: RequestParams = {},
    ) =>
      this.request<DeleteDeliveryDayItemResponse, void>({
        path: `/api/v1/DeliveryDay`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeliveryDay
     * @name V1DeliveryDayAuditList
     * @summary [Roles: user,guide,admin] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/DeliveryDay/audit
     * @secure
     */
    v1DeliveryDayAuditList: (
      query?: {
        /** @format uuid */
        momId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CheckListAuditDto, void>({
        path: `/api/v1/DeliveryDay/audit`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeliveryDay
     * @name V1DeliveryDayCopyList
     * @summary [Roles: user] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/DeliveryDay/copy
     * @secure
     */
    v1DeliveryDayCopyList: (params: RequestParams = {}) =>
      this.request<PagedCheckListItemResponse, void>({
        path: `/api/v1/DeliveryDay/copy`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags InsuranceProvider
     * @name V1InsuranceProviderGetInsuranceProvidersList
     * @summary [Unprotected]
     * @request GET:/api/v1/InsuranceProvider/GetInsuranceProviders
     * @secure
     */
    v1InsuranceProviderGetInsuranceProvidersList: (
      query?: {
        searchString?: string;
        /**
         * @format int32
         * @default 1
         */
        page?: number;
        /**
         * @format int32
         * @default 20
         */
        pageSize?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetInsuranceProvidersResponsePagedResponse, any>({
        path: `/api/v1/InsuranceProvider/GetInsuranceProviders`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PreAdmission
     * @name V1PreAdmissionCreatePreAdmissionCreate
     * @summary [Unprotected]
     * @request POST:/api/v1/PreAdmission/CreatePreAdmission
     * @secure
     */
    v1PreAdmissionCreatePreAdmissionCreate: (
      data: CreateADT05Dto,
      params: RequestParams = {},
    ) =>
      this.request<boolean, any>({
        path: `/api/v1/PreAdmission/CreatePreAdmission`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Resource
     * @name V1ResourceLandingList
     * @summary [Roles: user] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/Resource/landing
     * @secure
     */
    v1ResourceLandingList: (params: RequestParams = {}) =>
      this.request<GetResourceLandingResponse, void>({
        path: `/api/v1/Resource/landing`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Resource
     * @name V1ResourceFavoritesList
     * @summary [Roles: user] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/Resource/favorites
     * @secure
     */
    v1ResourceFavoritesList: (
      query?: {
        /** @format int32 */
        Page?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ResourceItemDtoPagedResponse, void>({
        path: `/api/v1/Resource/favorites`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Resource
     * @name V1ResourceFavoriteCreate
     * @summary [Roles: user] [Policy: RequireVerifiedUser]
     * @request POST:/api/v1/Resource/favorite
     * @secure
     */
    v1ResourceFavoriteCreate: (
      data: AddFavoriteResourceDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/Resource/favorite`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Resource
     * @name V1ResourceFavoriteDelete
     * @summary [Roles: user] [Policy: RequireVerifiedUser]
     * @request DELETE:/api/v1/Resource/favorite
     * @secure
     */
    v1ResourceFavoriteDelete: (
      data: DeleteFavoriteResourceDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/Resource/favorite`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Resource
     * @name V1ResourceSharedList
     * @summary [Roles: user] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/Resource/shared
     * @secure
     */
    v1ResourceSharedList: (
      query?: {
        /** @format int32 */
        Page?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ResourceItemDtoPagedResponse, void>({
        path: `/api/v1/Resource/shared`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Resource
     * @name V1ResourceCategoryList
     * @summary [Roles: user,guide,admin] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/Resource/category
     * @secure
     */
    v1ResourceCategoryList: (
      query?: {
        /** @format int32 */
        CategoryId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetResourceCategoryResponse, void | ErrorResponse>({
        path: `/api/v1/Resource/category`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Resource
     * @name V1ResourceSearchList
     * @summary [Roles: user] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/Resource/search
     * @secure
     */
    v1ResourceSearchList: (
      query?: {
        /** @format int32 */
        CategoryId?: number;
        /** @format int32 */
        TypeId?: number;
        /** @format int32 */
        Page?: number;
        /** @format int32 */
        Limit?: number;
        Query?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ResourceItemDtoPagedResponse, void | ErrorResponse>({
        path: `/api/v1/Resource/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Resource
     * @name V1ResourceList
     * @summary [Roles: user] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/Resource
     * @secure
     */
    v1ResourceList: (
      query?: {
        /** @format int32 */
        ResourceId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetResourceResponse, void | ErrorResponse>({
        path: `/api/v1/Resource`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Resource
     * @name V1ResourceProviderSearchList
     * @summary [Unprotected]
     * @request GET:/api/v1/Resource/provider/search
     * @secure
     */
    v1ResourceProviderSearchList: (
      query?: {
        /**
         * @format int32
         * @default 10
         */
        limit?: number;
        /**
         * @format int32
         * @default 0
         */
        page?: number;
        query?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetProvidersResponsePagedResponse, ErrorResponse>({
        path: `/api/v1/Resource/provider/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Resource
     * @name V1ResourceProviderList
     * @summary [Unprotected]
     * @request GET:/api/v1/Resource/provider
     * @secure
     */
    v1ResourceProviderList: (
      query?: {
        ids?: number[];
      },
      params: RequestParams = {},
    ) =>
      this.request<GetProvidersByIdsResponse[], ErrorResponse>({
        path: `/api/v1/Resource/provider`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Resource
     * @name V1ResourceArticleList
     * @summary [Roles: user] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/Resource/article
     * @secure
     */
    v1ResourceArticleList: (
      query?: {
        /** @format int32 */
        ResourceId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetResourceResponse, void | ErrorResponse>({
        path: `/api/v1/Resource/article`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Resource
     * @name V1ResourceClassList
     * @summary [Roles: user] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/Resource/class
     * @secure
     */
    v1ResourceClassList: (
      query?: {
        /** @format int32 */
        ResourceId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetResourceResponse, void | ErrorResponse>({
        path: `/api/v1/Resource/class`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Resource
     * @name V1ResourceServiceList
     * @summary [Roles: user] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/Resource/service
     * @secure
     */
    v1ResourceServiceList: (
      query?: {
        /** @format int32 */
        ResourceId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetResourceResponse, void | ErrorResponse>({
        path: `/api/v1/Resource/service`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Resource
     * @name V1ResourceVideoList
     * @summary [Roles: user] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/Resource/video
     * @secure
     */
    v1ResourceVideoList: (
      query?: {
        /** @format int32 */
        ResourceId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetResourceResponse, void | ErrorResponse>({
        path: `/api/v1/Resource/video`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Resource
     * @name V1ResourceAudioList
     * @summary [Roles: user] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/Resource/audio
     * @secure
     */
    v1ResourceAudioList: (
      query?: {
        /** @format int32 */
        ResourceId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetResourceResponse, void | ErrorResponse>({
        path: `/api/v1/Resource/audio`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Resource
     * @name V1ResourceClassesList
     * @summary [Roles: user] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/Resource/classes
     * @secure
     */
    v1ResourceClassesList: (
      query?: {
        /** @format int32 */
        Page?: number;
        /** @format int32 */
        Limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetResourceResponse, void | ErrorResponse>({
        path: `/api/v1/Resource/classes`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Resource
     * @name V1ResourceCareTeamCategoriesList
     * @summary [Roles: guide,admin] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/Resource/careTeam/categories
     * @secure
     */
    v1ResourceCareTeamCategoriesList: (params: RequestParams = {}) =>
      this.request<GetResourceCategoriesResponse, void>({
        path: `/api/v1/Resource/careTeam/categories`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Resource
     * @name V1ResourceCareTeamShareCreate
     * @summary [Roles: guide] [Policy: RequireVerifiedUser]
     * @request POST:/api/v1/Resource/careTeam/share
     * @secure
     */
    v1ResourceCareTeamShareCreate: (
      data: AddSharedResourceDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/Resource/careTeam/share`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Resource
     * @name V1ResourceCareTeamShareDelete
     * @summary [Roles: guide] [Policy: RequireVerifiedUser]
     * @request DELETE:/api/v1/Resource/careTeam/share
     * @secure
     */
    v1ResourceCareTeamShareDelete: (
      data: RemoveSharedResourceDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/Resource/careTeam/share`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Resource
     * @name V1ResourceCareTeamShareCareTeamChatCreate
     * @summary [Roles: guide] [Policy: RequireVerifiedUser]
     * @request POST:/api/v1/Resource/careTeam/shareCareTeamChat
     * @secure
     */
    v1ResourceCareTeamShareCareTeamChatCreate: (
      data: ShareResourceCareTeamDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void | ErrorResponse>({
        path: `/api/v1/Resource/careTeam/shareCareTeamChat`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Resource
     * @name V1ResourceCareTeamSearchList
     * @summary [Roles: guide] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/Resource/careTeam/search
     * @secure
     */
    v1ResourceCareTeamSearchList: (
      query?: {
        /** @format uuid */
        UserId?: string;
        /** @format int32 */
        CategoryId?: number;
        /** @format int32 */
        Page?: number;
        /** @format int32 */
        Limit?: number;
        Query?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ResourceItemDtoPagedResponse, void | ErrorResponse>({
        path: `/api/v1/Resource/careTeam/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Resource
     * @name V1ResourceCareTeamList
     * @summary [Roles: rn,guide,admin,lc] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/Resource/careTeam
     * @secure
     */
    v1ResourceCareTeamList: (
      query?: {
        /** @format uuid */
        UserId?: string;
        /** @format int32 */
        ResourceId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetResourceResponse, void | ErrorResponse>({
        path: `/api/v1/Resource/careTeam`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Resource
     * @name V1ResourceCareTeamArticleList
     * @summary [Roles: rn,guide,admin] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/Resource/careTeam/article
     * @secure
     */
    v1ResourceCareTeamArticleList: (
      query?: {
        /** @format uuid */
        UserId?: string;
        /** @format int32 */
        ResourceId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetResourceResponse, void | ErrorResponse>({
        path: `/api/v1/Resource/careTeam/article`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Resource
     * @name V1ResourceCareTeamClassList
     * @summary [Roles: rn,guide,admin] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/Resource/careTeam/class
     * @secure
     */
    v1ResourceCareTeamClassList: (
      query?: {
        /** @format uuid */
        UserId?: string;
        /** @format int32 */
        ResourceId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetResourceResponse, void | ErrorResponse>({
        path: `/api/v1/Resource/careTeam/class`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Resource
     * @name V1ResourceCareTeamServiceList
     * @summary [Roles: rn,guide,admin] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/Resource/careTeam/service
     * @secure
     */
    v1ResourceCareTeamServiceList: (
      query?: {
        /** @format uuid */
        UserId?: string;
        /** @format int32 */
        ResourceId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetResourceResponse, void | ErrorResponse>({
        path: `/api/v1/Resource/careTeam/service`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Resource
     * @name V1ResourceCareTeamVideoList
     * @summary [Roles: rn,guide,admin] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/Resource/careTeam/video
     * @secure
     */
    v1ResourceCareTeamVideoList: (
      query?: {
        /** @format uuid */
        UserId?: string;
        /** @format int32 */
        ResourceId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetResourceResponse, void | ErrorResponse>({
        path: `/api/v1/Resource/careTeam/video`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Resource
     * @name V1ResourceCareTeamAudioList
     * @summary [Roles: rn,guide,admin] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/Resource/careTeam/audio
     * @secure
     */
    v1ResourceCareTeamAudioList: (
      query?: {
        /** @format uuid */
        UserId?: string;
        /** @format int32 */
        ResourceId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetResourceResponse, void | ErrorResponse>({
        path: `/api/v1/Resource/careTeam/audio`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Resource
     * @name V1ResourcePrenatalRoadmapList
     * @summary [Roles: user] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/Resource/prenatalRoadmap
     * @secure
     */
    v1ResourcePrenatalRoadmapList: (params: RequestParams = {}) =>
      this.request<GetPrenatalRoadmapeResponse, void | ErrorResponse>({
        path: `/api/v1/Resource/prenatalRoadmap`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Survey
     * @name V1SurveyOnboardingList
     * @summary [Roles: user] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/Survey/onboarding
     * @secure
     */
    v1SurveyOnboardingList: (params: RequestParams = {}) =>
      this.request<GetOnboardingSurveyResponse, void>({
        path: `/api/v1/Survey/onboarding`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Survey
     * @name V1SurveyOnboardingUpdate
     * @summary [Roles: user] [Policy: RequireVerifiedUser]
     * @request PUT:/api/v1/Survey/onboarding
     * @secure
     */
    v1SurveyOnboardingUpdate: (
      data: UpsertOnboardingSurveyDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/v1/Survey/onboarding`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Survey
     * @name V1SurveyCareTeamOnboardingList
     * @summary [Roles: rn,guide,admin] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/Survey/careTeam/onboarding
     * @secure
     */
    v1SurveyCareTeamOnboardingList: (
      query?: {
        /** @format uuid */
        UserId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetOnboardingSurveyResponse, void>({
        path: `/api/v1/Survey/careTeam/onboarding`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Video
     * @name V1VideoCreateAccessTokenCreate
     * @summary [Roles: user] [Policy: RequireVerifiedUser]
     * @request POST:/api/v1/Video/createAccessToken
     * @secure
     */
    v1VideoCreateAccessTokenCreate: (params: RequestParams = {}) =>
      this.request<CreateVideoAccessTokenResponse, void>({
        path: `/api/v1/Video/createAccessToken`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Video
     * @name V1VideoCareTeamCreateAccessTokenCreate
     * @summary [Roles: rn,lc] [Policy: RequireVerifiedUser]
     * @request POST:/api/v1/Video/careTeam/createAccessToken
     * @secure
     */
    v1VideoCareTeamCreateAccessTokenCreate: (
      data: CreateCareTeamVideoAccessTokenDto,
      params: RequestParams = {},
    ) =>
      this.request<CreateVideoAccessTokenResponse, void>({
        path: `/api/v1/Video/careTeam/createAccessToken`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Voice
     * @name V1VoiceCreateAccessTokenCreate
     * @summary [Roles: user,rn,lc] [Policy: RequireVerifiedUser]
     * @request POST:/api/v1/Voice/createAccessToken
     * @secure
     */
    v1VoiceCreateAccessTokenCreate: (params: RequestParams = {}) =>
      this.request<CreateVoiceAccessTokenResponse, void>({
        path: `/api/v1/Voice/createAccessToken`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Voice
     * @name V1VoiceCallSummaryList
     * @summary [Roles: rn,guide,admin] [Policy: RequireVerifiedAndSubscribedUser]
     * @request GET:/api/v1/Voice/callSummary
     * @secure
     */
    v1VoiceCallSummaryList: (
      query?: {
        /** @format uuid */
        Id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CallSummaryDto, void>({
        path: `/api/v1/Voice/callSummary`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Voice
     * @name V1VoiceCallSummaryUpdate
     * @summary [Roles: rn,guide] [Policy: RequireVerifiedAndSubscribedUser]
     * @request PUT:/api/v1/Voice/callSummary
     * @secure
     */
    v1VoiceCallSummaryUpdate: (
      data: UpsertCallSummaryDto,
      params: RequestParams = {},
    ) =>
      this.request<CallSummaryDto, void>({
        path: `/api/v1/Voice/callSummary`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Voice
     * @name V1VoiceCallSummaryCategoriesList
     * @summary [Roles: rn,guide,admin] [Policy: RequireVerifiedAndSubscribedUser]
     * @request GET:/api/v1/Voice/callSummary/categories
     * @secure
     */
    v1VoiceCallSummaryCategoriesList: (params: RequestParams = {}) =>
      this.request<GetCallSummaryCategoriesResponse, void>({
        path: `/api/v1/Voice/callSummary/categories`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Voice
     * @name V1VoiceDialList
     * @summary [Roles: user] [Policy: RequireVerifiedUser]
     * @request GET:/api/v1/Voice/dial
     * @secure
     */
    v1VoiceDialList: (params: RequestParams = {}) =>
      this.request<GetTriageNumberResponse, void>({
        path: `/api/v1/Voice/dial`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Voice
     * @name V1VoiceCallCommentCreate
     * @summary [Roles: user] [Policy: RequireVerifiedUser]
     * @request POST:/api/v1/Voice/callComment
     * @secure
     */
    v1VoiceCallCommentCreate: (
      data: CallCommentDto,
      params: RequestParams = {},
    ) =>
      this.request<CallCommentDto, void>({
        path: `/api/v1/Voice/callComment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Webhook
     * @name V1WebhookTwilioCreate
     * @summary [Roles: guide,rn,user,admin,lc]
     * @request POST:/api/v1/Webhook/twilio
     * @secure
     */
    v1WebhookTwilioCreate: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/v1/Webhook/twilio`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Webhook
     * @name V1WebhookTwilioCallCreate
     * @summary [Roles: guide,rn,user,admin,lc]
     * @request POST:/api/v1/Webhook/twilio/call
     * @secure
     */
    v1WebhookTwilioCallCreate: (
      data: {
        CallSid?: string;
        CallStatus?: string;
        CallStatusEnum?: CallStatus;
        From?: string;
        /** @format uuid */
        FromUserId?: string;
        To?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/v1/Webhook/twilio/call`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.UrlEncoded,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Webhook
     * @name V1WebhookTwilioDialActionCallbackCreate
     * @summary [Roles: guide,rn,user,admin,lc]
     * @request POST:/api/v1/Webhook/twilio/dialActionCallback
     * @secure
     */
    v1WebhookTwilioDialActionCallbackCreate: (
      data: {
        DialCallStatus?: string;
        DialCallStatusEnum?: CallStatus;
        DialCallSid?: string;
      },
      query?: {
        availableWorkers?: string;
        /** @format uuid */
        fromUserId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/v1/Webhook/twilio/dialActionCallback`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.UrlEncoded,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Webhook
     * @name V1WebhookTwilioCallStatusCreate
     * @summary [Roles: guide,rn,user,admin,lc]
     * @request POST:/api/v1/Webhook/twilio/callStatus
     * @secure
     */
    v1WebhookTwilioCallStatusCreate: (
      data: {
        CallSid?: string;
        CallStatus?: string;
        /** @format int32 */
        CallDuration?: number;
        CallStatusEnum?: CallStatus;
        From?: string;
        /** @format uuid */
        FromUserId?: string;
        To?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/v1/Webhook/twilio/callStatus`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.UrlEncoded,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Webhook
     * @name V1WebhookTwilioVideoRoomStatusCreate
     * @summary [Roles: guide,rn,user,admin,lc]
     * @request POST:/api/v1/Webhook/twilio/videoRoomStatus
     * @secure
     */
    v1WebhookTwilioVideoRoomStatusCreate: (
      data: {
        AccountSid?: string;
        RoomName?: string;
        RoomSid?: string;
        RoomStatus?: string;
        RoomType?: string;
        StatusCallbackEvent?: string;
        Timestamp?: Date;
        ParticipantSid?: string;
        ParticipantStatus?: string;
        /** @format int32 */
        ParticipantDuration?: number;
        ParticipantIdentity?: string;
        /** @format int32 */
        RoomDuration?: number;
        /** @format int32 */
        SequenceNumber?: number;
        TrackSid?: string;
        TrackKind?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/v1/Webhook/twilio/videoRoomStatus`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.UrlEncoded,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Webhook
     * @name V1WebhookTwilioTaskRouterAssignmentCallbackCreate
     * @summary [Roles: guide,rn,user,admin,lc]
     * @request POST:/api/v1/Webhook/twilio/taskRouterAssignmentCallback
     * @secure
     */
    v1WebhookTwilioTaskRouterAssignmentCallbackCreate: (
      data: {
        TaskAttributes?: string;
        ReservationSid?: string;
        WorkerSid?: string;
      },
      query?: {
        type?: WorkerType;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/v1/Webhook/twilio/taskRouterAssignmentCallback`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.UrlEncoded,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Webhook
     * @name V1WebhookUmbracoCreate
     * @summary [Roles: guide,rn,user,admin,lc]
     * @request POST:/api/v1/Webhook/umbraco
     * @secure
     */
    v1WebhookUmbracoCreate: (
      data: SharedWebhookEventDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/v1/Webhook/umbraco`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Webhook
     * @name V1WebhookOktaCreate
     * @summary [Roles: guide,rn,user,admin,lc]
     * @request POST:/api/v1/Webhook/okta
     * @secure
     */
    v1WebhookOktaCreate: (
      data: OktaWebhookPayloadDto,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/api/v1/Webhook/okta`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Webhook
     * @name V1WebhookOktaInlineTokenCreate
     * @summary [Roles: guide,rn,user,admin,lc]
     * @request POST:/api/v1/Webhook/okta/inline/token
     * @secure
     */
    v1WebhookOktaInlineTokenCreate: (
      data: OktaInlineHookPayloadDto,
      params: RequestParams = {},
    ) =>
      this.request<OktaInlineHookResponseDto, void>({
        path: `/api/v1/Webhook/okta/inline/token`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
